Ext.ns('mx');

/**
 * Описание виджетов для локализации, дополнительная кастомная локализация
 */

if (!mx.LocalizationDescriptor) {
    mx.LocalizationDescriptor = function() {};
}

mx.LocalizationDescriptor = mx.CommonsLocalizationDescriptor = Ext.extend(mx.LocalizationDescriptor, {
    /**
     * Список виджетов для локализации
     */
    getWidgets: function() {
        var widgets = [
            'mx.comp.ContactDetailsList',
            'mx.comp.AccountHostsList',
            'mx.comp.PagingToolbar',
            'mx.comp.CountrySelectCombo',
            'mx.comp.StateSelectCombo',
            'mx.comp.WeekField',
            'mx.comp.DayField',
            'mx.comp.GeoComboBox',
            'mx.comp.GeoTextField',
            'mx.comp.DrawCircle',
            'mx.app.widget.HelpForm',
            'mx.app.widget.EditPanel',
            'mx.app.widget.GeoRegionWindow',
            'mx.app.widget.MapForm',
            'mx.app.widget.PolygonForm',
            'mx.app.widget.UsersEditForm',
            'mx.app.widget.UsersInfoForm',
            'mx.app.widget.WindowForm',
            'mx.plugin.GridFilter',
            'mx.Abstract.ScheduleChart.MapWindow',
            'mx.app.page.main.settings.Users',
            'mx.app.widget.Audit',

            //not find
            'mx.app.widget.LocationRateEditForm',
            'mx.comp.SearchOnMapField',
        ];

        if (mx.CommonsLocalizationDescriptor.superclass.getWidgets) {
            widgets = widgets.concat(mx.CommonsLocalizationDescriptor.superclass.getWidgets.call(this));
        }

        return widgets;
    },

    getNavigables: function() {
        var navigables = [
            'mx.app.page.main.Settings',

            //not find
            'mx.app.page.main.dispatchSheet.Reports',
            'mx.app.page.main.settings.Accounts',
            'mx.app.page.main.settings.Settings',
        ];

        if (mx.CommonsLocalizationDescriptor.superclass.getNavigables) {
            navigables = navigables.concat(mx.CommonsLocalizationDescriptor.superclass.getNavigables.call(this));
        }

        return navigables;
    },

    /**
     * Дополнительная локализация
     *
     * @param localization объект mx.Localiztion
     * @param local        мапа с переводом
     */
    customLocalization: function(localization, local) {
        if (mx.CommonsLocalizationDescriptor.superclass.customLocalization) {
            mx.CommonsLocalizationDescriptor.superclass.customLocalization.apply(this, arguments);
        }

        if (local['mx.app.widget.ExpandableGridPanel']) {
            Ext.override(mx.app.widget.ExpandableGridPanel, {
                gridlabels: local['mx.app.widget.ExpandableGridPanel'],
            });
        }

        // special controls localisation:
        Ext.form.CheckboxGroup.prototype.blankText =
            local['Ext.form.CheckboxGroup'].blankText || 'You must select at least one item in this group';
        Ext.form.Field.prototype.invalidText =
            local['Ext.form.Field'].invalidText || 'The value in this field is invalid';
        Ext.form.TextField.prototype.blankText = local['Ext.form.TextField'].blankText || 'This field is required';
        Ext.form.ComboBox.prototype.loadingText = local['Ext.form.ComboBox'].loadingText || 'Loading...';
        Ext.grid.GridView.prototype.sortAscText = local['Ext.grid.GridView'].sortAscText || 'Sort ascending';
        Ext.grid.GridView.prototype.sortDescText = local['Ext.grid.GridView'].sortDescText || 'Sort descending';
        Ext.grid.GridView.prototype.columnsText = local['Ext.grid.GridView'].columnsText || 'Columns';
        Ext.ux.grid.Search.prototype.searchText = local['mx.app.core.termins'].search || 'Search';
    },
});
